// import { useState } from "react";

// function AffiliateUserLogin() {
//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     phone: "",
//     instagram: "",
//     youtube: "",
//     twitter: "",
//     linkedin: "",
//   });

//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });

//     setErrors({
//       ...errors,
//       [e.target.name]: "",
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     let newErrors = {};
//     const requiredFields = ["first_name", "last_name", "email"];

//     requiredFields.forEach((field) => {
//       if (!formData[field].trim()) {
//         newErrors[field] = `Enter ${field.replace(/([A-Z])/g, " $1")}`;
//       }
//     });

//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       return;
//     }

//     try {
//       const response = await fetch("http://localhost:5000/api/affiliate/register", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       const result = await response.json();
//       alert("✅ Registered Successfully!");
//       console.log(result);
//     } catch (err) {
//       alert("❌ Server Error. Please try again!");
//     }
//   };

//   return (
//     <div className="bg-[#f4f7ff] min-h-screen">

//       {/* Header */}
//       <header className="bg-white shadow-sm">
//         <div className="container d-flex justify-content-between align-items-center py-3">
//           <div className="d-flex align-items-center gap-2">
//             <div className="bg-primary text-white rounded p-2 fw-bold">A</div>
//             <div>
//               <div className="fw-bold text-dark fs-5">AffiliatePro</div>
//               <small className="text-muted">Partner Program</small>
//             </div>
//           </div>
//           <nav className="d-flex align-items-center gap-4">
//             <a className="text-muted text-decoration-none">How it Works</a>
//             <a className="text-muted text-decoration-none">Support</a>
//             <a className="text-primary fw-semibold text-decoration-none">Sign In</a>
//           </nav>
//         </div>
//       </header>

//       {/* Hero */}
//       <section className="container text-center py-5">
//         <h2 className="fw-bold fs-2 text-dark">Join Our Affiliate Program</h2>
//         <p className="text-muted mt-2 mx-auto" style={{ maxWidth: "600px" }}>
//           Partner with us and earn competitive commissions while promoting products you believe in.
//         </p>

//         {/* ✅ Feature Cards - Equal height */}
//         <div className="row mt-5 g-4">
          
//           <div className="col-md-4 d-flex">
//             <div className="bg-white rounded shadow-sm p-4 text-center h-100 w-100">
//               <div className="bg-success-subtle text-success fw-bold rounded-circle d-inline-flex align-items-center justify-content-center" style={{width:"45px", height:"45px"}}>
//                 $
//               </div>
//               <h5 className="mt-3 fw-bold">High Commissions</h5>
//               <p className="text-muted small">Earn up to 30% commission on referrals</p>
//             </div>
//           </div>

//           <div className="col-md-4 d-flex">
//             <div className="bg-white rounded shadow-sm p-4 text-center h-100 w-100">
//               <div className="bg-info-subtle text-info fw-bold rounded-circle d-inline-flex align-items-center justify-content-center" style={{width:"45px", height:"45px"}}>
//                 📈
//               </div>
//               <h5 className="mt-3 fw-bold">Real-time Analytics</h5>
//               <p className="text-muted small">Track earnings & conversions live</p>
//             </div>
//           </div>

//           <div className="col-md-4 d-flex">
//             <div className="bg-white rounded shadow-sm p-4 text-center h-100 w-100">
//               <div className="bg-warning-subtle text-warning fw-bold rounded-circle d-inline-flex align-items-center justify-content-center" style={{width:"45px", height:"45px"}}>
//                 🎧
//               </div>
//               <h5 className="mt-3 fw-bold">Dedicated Support</h5>
//               <p className="text-muted small">Our team helps you succeed and scale</p>
//             </div>
//           </div>

//         </div>
//       </section>

//       {/* ✅ Form */}
//       <div className="container my-5 d-flex justify-content-center">
//         <div className="card shadow-lg p-4 rounded-4 w-100" style={{ maxWidth: "600px" }}>
//           <h1 className="text-center fw-semibold mb-2 fs-5 text-dark">Create Your Affiliate Account</h1>
//           <p className="text-center mb-4 small text-muted">Fill the form to get started</p>

//           <form onSubmit={handleSubmit}>
//             {/* Personal Info */}
//             <h6 className="fw-bold mb-2"><i className="bi bi-person-fill text-primary"></i> Personal Information</h6>

//             <div className="row g-3 mb-3">
//               <div className="col-md-6">
//                 <label className="form-label small">First Name *</label>
//                 <input type="text" name="first_name" className={`form-control ${errors.first_name && "is-invalid"}`} placeholder="Enter first name" value={formData.first_name} onChange={handleChange} />
//                 <small className="text-danger">{errors.first_name}</small>
//               </div>

//               <div className="col-md-6">
//                 <label className="form-label small">Last Name *</label>
//                 <input type="text" name="last_name" className={`form-control ${errors.last_name && "is-invalid"}`} placeholder="Enter last name" value={formData.last_name} onChange={handleChange} />
//                 <small className="text-danger">{errors.last_name}</small>
//               </div>

//               <div className="col-12">
//                 <label className="form-label small">Email *</label>
//                 <input type="email" name="email" placeholder="your.email@example.com" className={`form-control ${errors.email && "is-invalid"}`} value={formData.email} onChange={handleChange} />
//                 <small className="text-danger">{errors.email}</small>
//               </div>

//               <div className="col-12">
//                 <label className="form-label small">Phone</label>
//                 <input type="tel" name="phone" placeholder="+91 XXXXX XXXXX" className="form-control" value={formData.phone} onChange={handleChange} />
//               </div>
//             </div>

//             {/* Social */}
//             <h6 className="fw-bold mb-2"><i className="bi bi-share-fill text-primary"></i> Social Media Profiles</h6>

//             <div className="row g-3 mb-3">
//               <div className="col-md-6">
//                 <input type="text" name="instagram" placeholder="Instagram" className="form-control" onChange={handleChange} />
//               </div>
//               <div className="col-md-6">
//                 <input type="url" name="youtube" placeholder="YouTube Channel" className="form-control" onChange={handleChange} />
//               </div>
//               <div className="col-md-6">
//                 <input type="text" name="twitter" placeholder="Twitter" className="form-control" onChange={handleChange} />
//               </div>
//               <div className="col-md-6">
//                 <input type="url" name="linkedin" placeholder="LinkedIn" className="form-control" onChange={handleChange} />
//               </div>
//             </div>

//             {/* Terms */}
//             <div className="form-check mb-3">
//               <input className="form-check-input" type="checkbox" required />
//               <label className="form-check-label small">I agree to the Terms & Affiliate Policy.</label>
//             </div>

//             {/* Submit */}
//             <button className="w-100 py-2 text-white fw-semibold border-0 rounded"
//               style={{ background: "linear-gradient(90deg,#2979ff,#a200ff)" }}>
//               Submit Application
//             </button>

//             <p className="text-center mt-3 small text-dark">
//               Already have an account?
//               <a href="#" className="text-primary text-decoration-none"> Sign in</a>
//             </p>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AffiliateUserLogin;


import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { postData, getData } from "../../../global/Globalapi";
import axios from "axios";
import { showAlert } from "../../DynamicComp/Alert";

function AffiliateUserLogin() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    instagram: "",
    youtube: "",
    twitter: "",
    linkedin: "",
  });
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

    setErrors({
      ...errors,
      [e.target.name]: ""
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};
    const requiredFields = ["first_name", "last_name", "email"];

    requiredFields.forEach((field) => {
      if (!formData[field].trim()) {
        newErrors[field] = `Enter ${field.replace(/([A-Z])/g, ' $1')}`;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const response = await postData("/affiliate-register", formData);

      const result = await response.data;
      console.log("Affiliate Register response:", result);
      showAlert(
                {
                  type: "success",
                  title: "Affiliate User registered Successfully!",
                  message: "Welcome back to your affiliate dashboard.",
                  duration: 3000,
                });
      console.log("Result",result);

    } catch (err) {
      console.error(err);
      alert("❌ Server Error. Please try again!");
    }
  };

  return (
    <div className=" min-h-screen">

      {/* ✅ Header */}
      <header className="border-bottom #f3ece3" style={{backgroundColor:"#f3ece3"}}>
        <div className="container d-flex justify-content-between align-items-center py-3">

          {/* Logo */}
          <div className="d-flex align-items-center gap-2 mt-3">
            <div className="bg-primary text-white rounded p-2 fw-bold mt-">A</div>
            <div>
              <div className="fw-bold text-dark">AffiliatePro</div>
              <small className="text-muted">Partner Program</small>
            </div>
          </div>

          {/* Navbar */}
          <nav className="d-flex align-items-center gap-4 mt-2">
            <a className="text-muted text-decoration-none">How it Works</a>
            <a className="text-muted text-decoration-none">Support</a>
            <a
                className="text-primary fw-semibold text-decoration-none"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault(); // Prevent page reload
                  navigate("/affiliateLogin"); // Navigate to AffiliateLogin page
                }}
              >
                Sign In
            </a>

          </nav>
        </div>
      </header>

      {/* ✅ Hero Section */}
      <section className="container text-center py-5 mt-4">
        <h2 className="fw-bold fs-2" style={{color:"#ffffffff"}}>Join Our Affiliate Program</h2>
        <p className="mt-2" style={{ maxWidth: "600px", margin: "0 auto" , color: "#f3ece3" }}>
          Partner with us and earn competitive commissions while promoting
          products you believe in. Start your affiliate journey today.
        </p>

        {/* ✅ Features */}
        <div className="row mt-5 g-4 justify-content-center">

  <div className="col-md-4 d-flex">
    <div className="bg-white rounded shadow-sm p-4 text-center h-100 w-100">
      <div className="bg-success-subtle text-success fw-bold rounded-circle d-inline-flex align-items-center justify-content-center"
        style={{ width:"40px", height:"40px" }}>
        $
      </div>
      <h5 className="mt-3 fw-bold">High Commissions</h5>
      <p className="text-muted small">Earn up to 30% commission on Referrals</p>
    </div>
  </div>

  <div className="col-md-4 d-flex">
    <div className="bg-white rounded shadow-sm p-4 text-center h-100 w-100">
      <div className="bg-info-subtle text-info fw-bold rounded-circle d-inline-flex align-items-center justify-content-center"
        style={{ width:"40px", height:"40px" }}>
        📈
      </div>
      <h5 className="mt-3 fw-bold">Real-time Analytics</h5>
      <p className="text-muted small">Track earnings and Conversation Live</p>
    </div>
  </div>

  <div className="col-md-4 d-flex">
    <div className="bg-white rounded shadow-sm p-4 text-center h-100 w-100">
      <div className="bg-warning-subtle text-warning fw-bold rounded-circle d-inline-flex align-items-center justify-content-center"
        style={{ width:"40px", height:"40px" }}>
        🎧
      </div>
      <h5 className="mt-3 fw-bold">Dedicated Support</h5>
      <p className="text-muted small">Our team helps you succeed and achieve</p>
    </div>
  </div>

</div>
</section>

      {/* ✅ Form Card */}
      <div className="container my-5 d-flex justify-content-center">
        <div
          className="card shadow-lg p-4 rounded-4 w-100"
          style={{
            maxWidth: "600px",
            minHeight: "80vh",
            borderRadius: "25px",
          }}
        >
          <h1 className="text-center fw-semibold mb-2 fs-5" style={{ color: "#000" }}>
            Create Your Affiliate Account
          </h1>

          <p className="text-center mb-4" style={{ color: "#000", fontSize: "14px" }}>
            Fill out the form below to get started with our affiliate program
          </p>

          {/* ✅ FORM */}
          <form onSubmit={handleSubmit}>
            <h5 className="fw-semibold mb-3">
              <i className="bi bi-person-fill text-primary"></i> Personal Information
            </h5>

            <div className="row g-3 mb-4">
              <div className="col-md-6">
                <label className="form-label">First Name *</label>
                <input
                  type="text"
                  name="first_name"
                  placeholder="Enter your first name"
                  className={`form-control ${errors.first_name && "is-invalid"}`}
                  value={formData.first_name}
                  onChange={handleChange}
                />
                <small className="text-danger">{errors.first_name}</small>
              </div>

              <div className="col-md-6">
                <label className="form-label">Last Name *</label>
                <input
                  type="text"
                  name="last_name"
                  placeholder="Enter your last name"
                  className={`form-control ${errors.last_name && "is-invalid"}`}
                  value={formData.last_name}
                  onChange={handleChange}
                />
                <small className="text-danger">{errors.last_name}</small>
              </div>

              <div className="col-12">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  name="email"
                  placeholder="your.email@example.com"
                  className={`form-control ${errors.email && "is-invalid"}`}
                  value={formData.email}
                  onChange={handleChange}
                />
                <small className="text-danger">{errors.email}</small>
              </div>

              <div className="col-12">
                <label className="form-label">Phone</label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="+91 XXXXX XXXXX"
                  className="form-control"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* ✅ Social Media */}
            <h5 className="fw-semibold mb-3">
              <i className="bi bi-share-fill text-primary"></i> Social Media Profiles
            </h5>

            <div className="row g-3 mb-4">
              <div className="col-md-6">
                <label className="form-label">Instagram</label>
                <input type="text" name="instagram" placeholder="@username" className="form-control" onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label className="form-label">YouTube</label>
                <input type="url" name="youtube" placeholder="Channel URL" className="form-control" onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Twitter</label>
                <input type="text" name="twitter" placeholder="@username" className="form-control" onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label className="form-label">LinkedIn</label>
                <input type="url" name="linkedin" placeholder="Profile URL" className="form-control" onChange={handleChange} />
              </div>
            </div>

            {/* ✅ Terms */}
            <div className="form-check mb-3">
                <input className="form-check-input" type="checkbox" required />
                <label className="form-check-label small">
                  I agree to the{" "}
                  <a href="#" style={{ color: "#2979ff", textDecoration: "underline" }}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/terms");
                      }}>
                    Terms of Service
                  </a>{" "}
                  and{" "}
                  <a href="#" style={{ color: "#2979ff", textDecoration: "underline" }} onClick={(e) => {
                      e.preventDefault();
                      navigate("/terms");
                    }}>
                    Affiliate Agreement
                  </a>
                  , and I understand that my application will be reviewed within 2-3 business days.
                </label>
            </div>


            {/* ✅ Submit */}
            <button
              className="w-100 py-2 text-white fw-semibold border-0 d-flex align-items-center justify-content-center gap-2"
              style={{ background: "linear-gradient(90deg, #2979ff 0%, #a200ff 100%)", borderRadius: "8px", marginTop: "25px" }}
            >
              <i className="bi bi-send mt-2"></i>
              Submit Application
            </button>

            <p className="text-center mt-3 small" style={{ color: "#000" }}>
              Already have an account?{" "}
              <a
                href="#"
                style={{ color: "#2979ff" }}
                onClick={(e) => {
                  e.preventDefault(); // Prevent page reload
                  navigate("/affiliateLogin"); // Navigate to AffiliateLogin page
                }}
              >
          Sign in here
        </a>
            </p>

          </form>
        </div>
      </div>
    </div>
  );
}

export default AffiliateUserLogin;
